module.exports = __webpack_public_path__ + "img/vuejs.81a22a19.png";